export default [
  {//选择违背原因
    name: 'violateList',
    path: '/violateList',
    component: resolve => require(['Components/violateList'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {//新建/修改申请单
    name: 'tripAdd',
    path: '/tripAdd',
    component: resolve => require(['Views/Home/tripList/tripAdd/index.vue'], resolve),
    meta: {
      include: ['TripAdd'],
      index: 1.1
    }
  },
  {//新增/修改 申请单行程
    name: 'tripRoute',
    path: '/tripRoute',
    component: resolve => require(['Views/Home/tripList/tripAdd/tripRoute/index.vue'], resolve),
    props:true,
    meta: {
      include: ['TripAdd', 'TripRoute'],
      index: 1.2
    }
  },
  {//申请单详情
    name: 'tripDetail',
    path: '/tripDetail',
    component: resolve => require(['Views/Home/tripList/detail.vue'], resolve),
    meta: {
      include: ['TripAdd', 'TripDetail'],
      index: 2
    }
  },
  {//支付页面
    name: 'payment',
    path: '/pay/payment',
    component: resolve => require(['Components/ldPay/index.vue'], resolve),
    props:true,
    meta: {
      include: [],
      index: 6
    }
  },
  // 联程跳转支付
  {
    name: 'ldPay',
    path: '/tk/ldPay',
    component: resolve => require(['Views/Tk/tkQuery/dc/ldPay/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  {//支付成功页面
    name: 'paySuccess',
    path: '/pay/paySuccess',
    component: resolve => require(['Components/ldPay/paySuccess.vue'], resolve),
    props:true,
    meta: {
      include: [],
      index: 7
    }
  },
  // 联程继续支付
  {//支付成功页面
    name: 'paySuccess',
    path: '/tk/paySuccess',
    component: resolve => require(['Views/Tk/tkQuery/dc/ldPay/paySuccess.vue'], resolve),
    props:true,
    meta: {
      include: [],
      index: 7
    }
  },
]
